export class Lead {
  id: number = 0;
  name: string = "";
  phone: string;
  phone_2: string;
  phone_3: string;
  email: string;
  gender: string;
  occupation: string;
  workplace: string;
  intrestedProjects: string;
  budget_from: string;
  budget_to: string;
  search: string;
  lead_source: string;
  assignAgent: number;
  broker: number;
  status: number;
  time: any;
  leadSourceId: number;
  company: string;
  intrestedUnitTypes: string;
  idNumber: number;
  isPrelead: boolean;
  agent_id: number;
  agent_ids: number[] = [];
  broker_id: number;
  date_of_birth: string;
  address: string;
  fax_num: string;
  work_adress: string;
  comment: string;
  id_address: String;
  lead_event_id: String;
  nationality: string;
  id_type: string;
  id_number: number;
  constructor() {
    this.id = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/dtos/lead.viewmodel.ts